// Estado do "acesso ao portal" de uma linha da carteira (PO1-2299): lógica
// pura, testável, que decide o rótulo da coluna Portal e as ações do drawer
// a partir de `acessoPortal` ({ temLoginAtivo, convite }) devolvido por
// GET /transportadoras/minhas. Sem `acessoPortal` (escopo inválido ou API
// antiga) a coluna mostra "—" e nenhuma ação aparece.

export const ESTADO_CONVITE = {
  EM_CURADORIA: "EM_CURADORIA",
  ENVIADO: "ENVIADO",
  FALHA_ENVIO: "FALHA_ENVIO",
  CANCELADO: "CANCELADO",
  RECUSADO_EVERLOG: "RECUSADO_EVERLOG",
  ACEITO: "ACEITO",
  RECUSADO: "RECUSADO",
};

const dois = (n) => String(n).padStart(2, "0");

export function formatarDiaMes(valor) {
  if (!valor) return "";
  const d = valor instanceof Date ? valor : new Date(valor);
  if (Number.isNaN(d.getTime())) return "";
  return `${dois(d.getDate())}/${dois(d.getMonth() + 1)}`;
}

export function conviteEstado(acessoPortal, { conviteHabilitado = true, esteira = null } = {}) {
  const base = { podeConvidar: false, podeReenviar: false, podeCancelar: false, podeConectar: false, convite: null };
  if (!acessoPortal) return { ...base, tipo: "sem-escopo", rotulo: "—", badge: "lock" };
  // PO1-3166: quem já acessa o portal NÃO precisa de convite — mas o vínculo
  // ainda precisa ser conectado, e antes disso a linha ficava sem ação nenhuma,
  // dando a impressão de que não havia o que fazer (achado do Rodrigo em
  // 20/09/2026, tentando conectar a Braspress à 100% Amazônia).
  //
  // `podeConectar` é diferente de `podeConvidar`: não manda e-mail, só cria a
  // habilitação daquele par. `esteira` vem do GET /transportadoras/minhas; sem
  // ela (vínculo antigo, ou API mais velha) a ação aparece do mesmo jeito, e o
  // backend é idempotente.
  if (acessoPortal.temLoginAtivo) {
    const conectado = !!(esteira && esteira.fase);
    return {
      ...base,
      tipo: "com-acesso",
      rotulo: "Com acesso",
      badge: "done",
      podeConectar: !conectado,
    };
  }

  const convite = acessoPortal.convite || null;
  const comConvite = { ...base, convite };
  if (convite) {
    // R8: EM_CURADORIA = travado até a Everlog ajustar a matriz (0001).
    if (convite.estado === ESTADO_CONVITE.EM_CURADORIA) {
      return { ...comConvite, tipo: "curadoria", rotulo: "Ajuste de matriz (Everlog)", badge: "pend", podeCancelar: true };
    }
    if (convite.estado === ESTADO_CONVITE.ENVIADO && convite.expirado) {
      return { ...comConvite, tipo: "expirado", rotulo: "Expirado", badge: "pend", podeReenviar: conviteHabilitado, podeCancelar: true };
    }
    if (convite.estado === ESTADO_CONVITE.ENVIADO) {
      const ate = formatarDiaMes(convite.expiraEm);
      return { ...comConvite, tipo: "enviado", rotulo: ate ? `Enviado até ${ate}` : "Enviado", badge: "auto", podeReenviar: conviteHabilitado, podeCancelar: true };
    }
    if (convite.estado === ESTADO_CONVITE.FALHA_ENVIO) {
      return { ...comConvite, tipo: "falha", rotulo: "Falha no envio", badge: "pend", podeReenviar: conviteHabilitado, podeCancelar: true };
    }
    if (convite.estado === ESTADO_CONVITE.RECUSADO_EVERLOG) {
      return { ...comConvite, tipo: "recusado-everlog", rotulo: "Recusado pela Everlog", badge: "pend", podeConvidar: conviteHabilitado };
    }
    if (convite.estado === ESTADO_CONVITE.RECUSADO) {
      return { ...comConvite, tipo: "recusado", rotulo: "Recusou o convite", badge: "pend", podeConvidar: conviteHabilitado };
    }
  }
  // Sem convite aberto (nunca convidada, cancelado, aceito sem login ativo...):
  // pode convidar quando a jornada está ligada.
  return { ...comConvite, tipo: conviteHabilitado ? "convidar" : "indisponivel", rotulo: "Sem acesso", badge: "lock", podeConvidar: conviteHabilitado };
}
